





import PopupNovo from '~/components/Home/PopupNovo.vue';
import { popups_novos, popups_visualizados } from '~/store/popup-novo';

export default {
    components: {
        PopupNovo
    },
    computed: {
        popup() {
            return popups_novos.value.find(row => {
                if (!row.areas.includes('menu')) {
                    return false
                }
                if (popups_visualizados.value.includes(row.id)) {
                    return false
                }
                return true
            })
        },
    },
    mounted() { 
        this.$store.commit('setDrawer', true)
    },  
    unmounted() {
        this.$store.commit('setDrawer', false)
    }  
}
